export interface PublicNavLink {
  to: string;
  label: string;
}

export const publicNavLinks: PublicNavLink[] = [
  { to: '/features', label: 'Features' },
  { to: '/commands', label: 'Commands' },
  { to: '/docs', label: 'Docs' },
  { to: '/status', label: 'Status' },
  { to: '/changelog', label: 'Changelog' },
  { to: '/team', label: 'Team' },
];
